import StyledButton from "@stadium/ui/src/components/button/styled-button";
import PersonalWorkspaceNudge from "@stadium/shared/src/components/personal-workspace-nudge";
import { PersonalWorkspaceNudgeVariant } from "@stadium/shared/src/constants/personal-workspace-nudge";
import { useWorkspaceContext } from "@contexts/workspace-context";

import styles from "./main.module.scss";

const MobileMenuIcon = ({ isMobileNavOpen, setIsMobileNavOpen }) => {
  const workspaceContext = useWorkspaceContext() as any;
  const isPersonalWorkspace = workspaceContext?.isPersonalWorkspace;
  const activeClassName = isMobileNavOpen ? styles.menuIconActive : "";

  return (
    <div className={styles.menuIconWithNudge}>
      <PersonalWorkspaceNudge
        variant={PersonalWorkspaceNudgeVariant.RESPONSIVE}
        show={isPersonalWorkspace}
      />
      <StyledButton
        styleType="icon-btn"
        onClick={() => setIsMobileNavOpen(!isMobileNavOpen)}
        className={`${styles.navBarToggle} ${activeClassName}`}
      >
        <i className={styles.iconMenu}></i>
      </StyledButton>
    </div>
  );
};

export default MobileMenuIcon;
